export default __webpack_public_path__ + "static/media/support.c38df6b6.svg";